import React from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { Growl } from "primereact/growl";
import { Calendar } from "primereact/calendar";
import { Paginator } from 'primereact/paginator';

import ServicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';
import ServicioArchivos from '../servicio/ServicioArchivos';
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';

const TODOS = { label: "Todos", value: 0 };
const JOIN_PRINCIPAL = {
    "ttUsuario": "alias_ttUsuario",
    "tcEmpresa": "alias_tcEmpresa"
};
export class HistoricoDeMovimientos extends React.Component {

    constructor() {
        super();
        this.state = {
            mostrarTablaConsolidado: false,
            consolidado: [
                { label: "Consolidado", value: null },
                { label: "Exitos", value: "2" },
                { label: "Erroneos", value: "1" },

            ],
            archivo: null,
            historicoDeMovimiento: {},
            verModalHistoricoDeMovimientos: false,
            verModalHistoricoDeMovimientosLote: false,
            verModalHistoricoDeMovimientosRespuesta: false,
            movimientos: [],
            tamañoLote: null,
            lote: null,
            registrosPatronales: [],
            registroPatronal: 0,
            solicitud: null,
            paginacion: { registrosPorPagina: 10, join: { "tcEmpresa": "alias_tcEmpresa", "ttUsuario": "alias_ttUsuario" } },
            idsenube: 0,
            paginacionMovimientos: { registrosPorPagina: 10 },
            errores: {},
            listaMovimientos: [],
            resumenMovimientos: {},
            movimientosEncontrados: [],
            fecha: {},
            consulta: {}
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }
    cerrarModalLote = () => {
        this.setState({ verModalHistoricoDeMovimientosLote: false, verModalHistoricoDeMovimientosRespuesta: false, listaMovimientos: [] });
        this.setState({ verModalHistoricoDeMovimientosLote: false, verModalHistoricoDeMovimientosRespuesta: false, paginacionMovimientos: { registrosPorPagina: 10 }, mostrarTablaConsolidado: false, consulta: {}, listaMovimientos: [] });
    }

    resetFormulario = () => {

        this.setState({ verModalHistoricoDeMovimientos: false, listaMovimientos: [] });
        this.setState({
            historicoDeMovimiento: {},
            mostrarModalHistoricoDeMovimientos: false,
            errores: {},
        });
    };


    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = 0;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    };

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.buscar();
    }

    paginar = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp("solicitud/consultas.json", paginacion).then((response) => {
            this.growl.show({ severity: response.data.error === false ? "success" : "error", summary: "", detail: response.data.mensaje, });
            this.setState({ paginacion: response.data.objeto });
        }).catch((error) => {
            this.growl.show({
                severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
            });
        });
    }

    buscar() {
        let { fecha, registroPatronal } = this.state;
        const validacion = this.validarFormulario(fecha, registroPatronal);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            this.asginarRestriccionesDinamicasFrmBusqueda();
            this.paginar();
        }
    }

    asginarRestriccionesDinamicasFrmBusqueda = () => {
        let { fecha, registroPatronal, paginacion, registrosPatronales } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        paginacion.ordenamientos = [];
        let fechaIncial = servicioFormatos.formatearFechaString(fecha.fechaInicial);
        let fechaFinal = servicioFormatos.formatearFechaString(fecha.fechaFinal).replace('00:00:00', '23:59:59');

        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "between", nombrePropiedad: "fecha",
            fechaIncialBetween: fechaIncial, fechaFinalBetween: fechaFinal
        });

        if (registroPatronal !== 0) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq", nombrePropiedad: "alias_tcEmpresa.id", valorPropiedad: registroPatronal
            });
        } else {
            let empresasUsuarioSesion = [];
            for (let index = 0; index < registrosPatronales.length; index++) {
                let elemento = registrosPatronales[index];
                if (elemento.value !== 0) {
                    let valor = elemento.value;
                    empresasUsuarioSesion.push(
                        valor
                    );
                }
            }
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "in",
                nombrePropiedad: "alias_tcEmpresa.id",
                coleccionIn: empresasUsuarioSesion
            });
        }

        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "isNotNull",
            nombrePropiedad: "loteIdImss",

        });
        paginacion.ordenamientos.push({
            tipo: 'desc',
            nombrePropiedad: 'fecha'
        });

        this.setState({ paginacion });
    }

    buscarMovimientosAfiliatorios = () => {
        let { paginacionMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consultar_detalle_movimientos_historico.json", paginacionMovimientos).then((response) => {
            this.setState({ paginacionMovimientos: response.data.objeto });
        }).catch((error) => {
            this.growl.show({
                severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
            });
        });

    }

    buscarMovimientosConsolidado = () => {
        let { paginacionMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consultar_detalle_movimientos_historico.json", paginacionMovimientos).then((response) => {
            if (response.data.objeto.registrosTotales > 0) {
                this.setState({ paginacionMovimientos: response.data.objeto, mostrarTablaConsolidado: true });
            } else {
                paginacionMovimientos.datos = [];
                this.setState({ paginacionMovimientos });
                this.growl.show({
                    severity: "error", summary: "", detail: "No existen datos con la restriccion sugerida",
                });

            }
        }).catch((error) => {
            this.growl.show({
                severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
            });
        });
    }

    cambiaPaginaMovimientos = (event) => {
        let { paginacionMovimientos } = this.state;
        paginacionMovimientos.numeroPagina = event.page;
        paginacionMovimientos.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacionMovimientos });
        this.buscarMovimientosAfiliatorios();
    }


    obtenerMovimientosRespuesta(objeto) {
        let loteSolicitud = {};
        loteSolicitud.id = objeto.id;
        let { listaMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consultar_movimientos.json", loteSolicitud).then((response) => {
            let labelIngresos = "Ingresos";
            let labelModificacione = "Modificaciones";
            let labelBajas = "Bajas";
            let contadorIngresos = 0;
            let contadorBajas = 0;
            let contadorModificaciones = 0;
            let contadorIgresosError = 0;
            let contadorBajasError = 0;
            let contadorModificacionesError = 0;
            let contadorIngresosAceptados = 0;
            let contadorBajasAceptados = 0;
            let contadorModificacionesAceptados = 0;
            for (var i = 0; i < response.data.objeto.datos.length; i++) {
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorBajas++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorIngresos++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorModificaciones++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorBajasAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorIngresosAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorModificacionesAceptados++;
                }

                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorBajasError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorIgresosError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta !== null) {
                    contadorModificacionesError++;
                }
            }

            listaMovimientos.push({ tipoMovimiento: labelIngresos, total: contadorIngresos, error: contadorIgresosError, aceptados: contadorIngresosAceptados },
                { tipoMovimiento: labelModificacione, total: contadorModificaciones, error: contadorModificacionesError, aceptados: contadorModificacionesAceptados },
                { tipoMovimiento: labelBajas, total: contadorBajas, error: contadorBajasError, aceptados: contadorBajasAceptados });

            this.setState({ verModalHistoricoDeMovimientosRespuesta: true, historicoDeMovimiento: objeto });

        }).catch(() => { });
    }

    obtenerMovimientoSolicitud(objeto) {
        let loteSolicitud = {};
        loteSolicitud.id = objeto.id;
        let { listaMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consultar_movimientos.json", loteSolicitud).then((response) => {
            let labelIngresos = "Ingresos";
            let labelModificacione = "Modificaciones";
            let labelBajas = "Bajas";
            let contadorIngresos = 0;
            let contadorBajas = 0;
            let contadorModificaciones = 0;
            let contadorIgresosError = 0;
            let contadorBajasError = 0;
            let contadorModificacionesError = 0;
            let contadorIngresosAceptados = 0;
            let contadorBajasAceptados = 0;
            let contadorModificacionesAceptados = 0;
            for (var i = 0; i < response.data.objeto.datos.length; i++) {
                if (response.data.objeto.datos[i].tipoMovimiento === "02") {
                    contadorBajas++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08") {
                    contadorIngresos++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07") {
                    contadorModificaciones++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1) {
                    contadorBajasAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1) {
                    contadorIngresosAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1) {
                    contadorModificacionesAceptados++;
                }

                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionError !== null && response.data.objeto.datos[i].estado === 1) {
                    contadorBajasError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionError !== null && response.data.objeto.datos[i].estado === 1) {
                    contadorIgresosError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionError !== null && response.data.objeto.datos[i].estado === 1) {
                    contadorModificacionesError++;
                }
            }

            listaMovimientos.push({ tipoMovimiento: labelIngresos, total: contadorIngresos, error: contadorIgresosError, aceptados: contadorIngresosAceptados },
                { tipoMovimiento: labelModificacione, total: contadorModificaciones, error: contadorModificacionesError, aceptados: contadorModificacionesAceptados },
                { tipoMovimiento: labelBajas, total: contadorBajas, error: contadorBajasError, aceptados: contadorBajasAceptados });

            this.setState({ verModalHistoricoDeMovimientos: true, historicoDeMovimiento: objeto });

        }).catch(() => { });
    }

    mostrarModalHistoricoDeMovimientos = () => {
        this.setState({ verModalHistoricoDeMovimientos: true });
    };
    verRespuesta(objeto) {
        this.obtenerMovimientosRespuesta(objeto);
    }

    descargarAfil(elemento) {
        ServicioArchivos.descargaArchivo("/solicitud/descargarAfil.json", { id: elemento.id }, this);
    }

    descargarAcuse(elemento) {
        ServicioArchivos.descargaArchivo("/solicitud/descargarAcuse.json", { id: elemento.id }, this);
    }

    descargaMasiva = () => {
        let { paginacion } = this.state;
        ServicioArchivos.descargaArchivo('/solicitud/descargaMasivaAfil.json', paginacion.datos);
    }

    consultar = (objeto) => {
        this.obtenerMovimientoSolicitud(objeto);
    }

    consultarLote = (lote) => {
        this.setState({
            historicoDeMovimiento: lote,
            verModalHistoricoDeMovimientosLote: true
        });
        let { paginacionMovimientos } = this.state;
        paginacionMovimientos.restriccionesDinamicas = [];
        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "alias_ttLoteSolicitudIdse.id",
            valorPropiedad: lote.id

        });
        this.setState({ paginacionMovimientos });
        this.buscarMovimientosAfiliatorios();
    }

    plantillaEstado(rowData, column) {
        if (column.rowData.estado === 0)
            return <p >{"En proceso"}</p>
        if (column.rowData.estado === 1)
            return <p >{"Enviado al Imss"}</p>
        if (column.rowData.estado === 2)
            return <p >{"Respuesta del Imss"}</p>
    }

    columnaFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
    }

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    };

    validarFormulario = (objeto, registroPatronal) => {
        const errores = {};
        if (ServicioObjetos.esObjetoVacio(objeto.fechaInicial))
            errores.fechaInicial = "Seleccione Fecha Inicial";
        if (ServicioObjetos.esObjetoVacio(objeto.fechaFinal))
            errores.fechaFinal = "Seleccione Fecha FInal";
        if (ServicioObjetos.esObjetoVacio(registroPatronal))
            errores.registroPatronal = "Seleccione Registro Patronal";
        return errores;
    }

    plantillaConsultar(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">
                    <Button
                        label="Acuse"
                        type="button"
                        icon="pi-md-file-download"
                        onClick={() => this.consultar(rowData)}
                    ></Button>
                </div>
            </div>
        );
    }



    plantillaRespuesta(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">

                    <Button
                        label="Consultar"
                        type="button"
                        icon="pi-md-search"
                        onClick={() => this.verRespuesta(rowData)}
                    ></Button>

                </div>
            </div>
        );
    }
    plantillaModalRespuesta(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">
                    {!ServicioObjetos.esObjetoVacio(rowData.archivoAfil) ?
                        <Button
                            label="Respuesta"
                            type="button"
                            icon="pi-md-file-download"
                            onClick={() => this.descargarAfil(rowData)}
                        ></Button>
                        : "En proceso"}
                </div>
            </div>
        );
    }

    plantillaLoteImss(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">
                    {!ServicioObjetos.esObjetoVacio(rowData.loteIdImss) ?
                        <Button
                            label={rowData.loteIdImss}
                            type="button"
                            onClick={() => this.consultarLote(rowData)}
                        ></Button>
                        : "En proceso"}
                </div>
            </div>
        );

    }
    templateFechaMovimiento = (rowData, column) => {
        return servicioFormatos.formatearFechaStringIdse(rowData.fechaMovimiento);
    }
    templateSalarioDiario = (rowData, column) => {
        return servicioFormatos.formatoSalarioDiarioIntegradoString(rowData.salarioDiarioIntegrado);
    }

    templateNombre = (rowData, column) => {
        return servicioFormatos.formatearNombreTrabajador(rowData);
    }
    templateOperacionExitosa = (rowData, column) => {
        let { historicoDeMovimiento } = this.state;
        if (historicoDeMovimiento.fechaRecepcion !== null) {
            return <label >OPERACIÓN EXITOSA</label>
        } else {
            return <label >LOTE CAPTURADO</label>
        }
    }

    validarCambioConsolidado = (e) => {
        this.asignarValores(e);
        if (e.value === null) {
            this.setState({ mostrarTablaConsolidado: false });
            return;
        }
        let estado=0;
        if (e.value === "1") {
            estado=1;
        }
        if (e.value === "2") {
            estado=0;
        }
        let { paginacionMovimientos, historicoDeMovimiento } = this.state;
        paginacionMovimientos.restriccionesDinamicas = [];
        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "alias_ttLoteSolicitudIdse.id",
            valorPropiedad: historicoDeMovimiento.id

        });
        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "isNotNull",
            nombrePropiedad: "alias_ttLoteSolicitudIdse.fechaRespuesta"

        });
        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "estadoRespuesta",
            valorPropiedad: estado

        });
        paginacionMovimientos.restriccionesDinamicas.push({
            tipoRestriccion: "isNull",
            nombrePropiedad: "descripcionError",


        });
        this.buscarMovimientosConsolidado();        
    }
    regresarVistaRespuesta = () => {
        this.setState({ mostrarTablaConsolidado: false });
    }
    salirModalRespuesta = () => {
        this.setState({ verModalHistoricoDeMovimientosLote: false, verModalHistoricoDeMovimientosRespuesta: false, paginacionMovimientos: { registrosPorPagina: 10 }, mostrarTablaConsolidado: false, consulta: {}, listaMovimientos: [] });
    }


    plantillaTxt = (rowData, column) => {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-2">
                    {!ServicioObjetos.esObjetoVacio(rowData.archivoAfil) ?
                        <Button
                            label="Txt"
                            type="button"
                            icon="pi-md-insert-drive-file"
                            onClick={() => this.descargarAfilTxt(rowData)}
                        ></Button>
                        : "En proceso"}
                </div>
            </div>
        );
    }

    descargarAfilTxt = (elemento) => {
        ServicioArchivos.descargaArchivo("/solicitud/descargar_afil_txt.json", { id: elemento.id }, this);
    }

    render() {
        let { mostrarTablaConsolidado, paginacionMovimientos, historicoDeMovimiento, paginacion, errores, listaMovimientos, idsenube, fecha, consulta, consolidado } = this.state;
        const pieDialogoRespuesta = (
            <div className="ui-dialog-buttonpane p-clearfix">

                <Button
                    label="Salir"
                    icon="pi-md-close"
                    onClick={this.salirModalRespuesta}
                    className="p-button-danger "
                />

            </div>
        );
        return (
            <div>
                <div className="p-grid">
                    <Growl ref={(el) => (this.growl = el)} />
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <h1>Histórico de Movimientos</h1>
                            <div className="p-fluid p-grid">

                                <div className="p-col-12 p-md-2">
                                    <label >RPs Asociados:</label>
                                </div>
                                <div className="p-col-12 p-md-10">
                                    <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                                        options={this.state.registrosPatronales} value={this.state.registroPatronal}
                                        onChange={(event) => this.setState({ registroPatronal: event.value })} placeholder="Selecciona Asociados" />
                                    {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label >*Fechas de Transmisión: entre</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Calendar id="fechaInicial" name="fecha.fechaInicial" value={fecha.fechaInicial}
                                        placeholder="* Fecha Inicial" onChange={(e) => this.asignarValores(e, false)}
                                        className={errores.fechaInicial ? 'p-error' : ''} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                                    {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <center><label >y</label></center>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Calendar id="fechaFinal" name="fecha.fechaFinal" value={fecha.fechaFinal} placeholder="* Fecha Final"
                                        onChange={(e) => this.asignarValores(e, false)} className={errores.fechaFinal ? 'p-error' : ''}
                                        dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} />
                                    {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <Button label="Buscar" icon="pi-md-search" onClick={this.buscar.bind(this)} />
                                </div>
                                <div className="p-col-12 p-md-6">
                                    <Button label="Descarga masiva" icon="pi-md-folder" onClick={this.descargaMasiva.bind(this)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <DataTable value={paginacion.datos} editable={true}
                                selectionMode="single" responsive={true} header="Histórico de Movimientos">
                                <Column header="Lote" body={this.plantillaLoteImss.bind(this)} autoLayout={true} />
                                <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} />
                                <Column header="Fecha de transmisión" body={this.columnaFecha} autoLayout={true} />
                                <Column header="Acuse" body={this.plantillaConsultar.bind(this)} autoLayout={true} />
                                <Column header="Respuesta" body={this.plantillaRespuesta.bind(this)} autoLayout={true} />
                                <Column header="Constancia" body={this.plantillaModalRespuesta.bind(this)} autoLayout={true} />
                                <Column header="Txt" body={this.plantillaTxt} autoLayout={true} />
                                <Column header="Estatus" body={this.plantillaEstado.bind(this)} autoLayout={true} />
                            </DataTable>
                            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                </div>
                <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={this.state.verModalHistoricoDeMovimientos} header="Movimientos Afiliatorios" modal={true} onHide={this.resetFormulario.bind(this)}>

                    <div className="p-grid form-group">

                        <table class="default">
                            <tr>
                                <td> <label style={{ fontWeight: 'bold' }}>Lote:</label></td>
                                <td>{historicoDeMovimiento.loteIdImss}</td>
                            </tr>
                            <tr>
                                <td><label style={{ fontWeight: 'bold' }}>Registro Patronal:</label></td>
                                <td>{historicoDeMovimiento.registroPatronal}</td>
                            </tr>
                            <tr>
                                <td>
                                    <label style={{ fontWeight: 'bold' }}>
                                        Fecha de transmisión:
                                    </label>
                                </td>
                                <td>
                                    {servicioFormatos.formatearFecha(historicoDeMovimiento.fecha)}
                                </td>
                            </tr>
                            <tr>
                                <label style={{ fontWeight: 'bold' }}>
                                    <td>Fecha de Acuse Recibido:</td>
                                </label>
                                <td>{servicioFormatos.formatearFecha(historicoDeMovimiento.fechaRecepcion)}</td>
                            </tr>
                            <tr>
                                <label style={{ fontWeight: 'bold' }}>
                                    <td>Estatus del lote:</td>
                                </label>
                                <td>{historicoDeMovimiento.estado === 0 ? <label>  En Proceso  </label> : null}
                                    {historicoDeMovimiento.estado === 1 ? <label>  Enviado al IMSS  </label> : null}
                                    {historicoDeMovimiento.estado === 2 ? <label>  Respuesta del IMSS  </label> : null}</td>
                            </tr>
                        </table>
                        <div className="p-col-12">
                            <div className="card card-w-title">
                                <DataTable value={listaMovimientos} editable={true} selectionMode="single" responsive={true} header="Movimientos Afiliatorios" paginator={true} rows={20}>
                                    <Column header="Tipo de Movimiento" field="tipoMovimiento" autoLayout={true} />
                                    <Column header="Total" field="total" autoLayout={true} />
                                    <Column header="Error" field="error" autoLayout={true} />
                                    <Column header="Aceptados" field="aceptados" autoLayout={true} />
                                </DataTable>
                            </div>
                        </div>

                        <div className="p-col-12 p-md-5">
                            {!ServicioObjetos.esObjetoVacio(historicoDeMovimiento.archivoAcuseRecibo) ?
                                <Button className="p-button-success" label="Bajar Comprobante" icon="pi-md-import-export" onClick={() => this.descargarAcuse(historicoDeMovimiento)} />
                                : "En proceso"}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label ></label>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label ></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button className="p-button-danger" label="Cerrar" icon="pi-md-close" onClick={this.resetFormulario.bind(this)} />
                        </div>
                    </div>
                </Dialog>

                <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={this.state.verModalHistoricoDeMovimientosLote} footer={pieDialogoRespuesta} header="Movimientos Afiliatorios"
                    onHide={this.cerrarModalLote.bind(this)} modal={true}>
                    <div className="card card-w-title">
                        <div className="p-grid form-group">

                            <div className="p-col-12 p-md-12">

                                <table class="default">
                                    <tr>

                                        <td><label style={{ fontWeight: 'bold' }}>Lote:</label></td>
                                        <td>{historicoDeMovimiento.loteIdImss}</td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Registro Patronal:</label></td>
                                        <td>{historicoDeMovimiento.registroPatronal}</td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>
                                            Fecha de transmisión:
                                        </label>
                                        </td>
                                        <td>
                                            {servicioFormatos.formatearFecha(historicoDeMovimiento.fecha)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Fecha de Acuse Recibido:</label></td>
                                        <td>{servicioFormatos.formatearFecha(historicoDeMovimiento.fechaRecepcion)}</td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Estatus del lote:</label></td>
                                        <td>{historicoDeMovimiento.estado === 0 ? <label>  En Proceso  </label> : null}
                                            {historicoDeMovimiento.estado === 1 ? <label>  Enviado al IMSS  </label> : null}
                                            {historicoDeMovimiento.estado === 2 ? <label>  Respuesta del IMSS  </label> : null}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <DataTable value={paginacionMovimientos.datos} responsive={true} header="Movimientos Afiliatorios" resizableColumns={true}>
                            <Column field="tipoMovimiento" header="Tipo Mov" autoLayout={true} resizableColumns={true} style={{ width: '80px' }} />
                            <Column field="numeroSeguridadSocial" header="NSS" autoLayout={true} resizableColumns={true}
                                style={{ width: '100px' }} />
                            <Column field="curp" header="CURP" autoLayout={true} resizableColumns={true}
                                style={{ width: '200px' }} />
                            <Column body={this.templateNombre} header="Nombre" autoLayout={true} resizableColumns={true}
                                style={{ width: '250px' }} />
                            <Column field={this.templateFechaMovimiento} header="Fecha Movimiento" autoLayout={true} resizableColumns={true}
                                style={{ width: '200px' }} />
                            <Column field="tipoTrabajador" header="Tipo Trab" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column header="Clave Trab" field="claveTrabajador" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column field="jornadaReducida" header="Sem/Jorn Red" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column field="tipoSalario" header="Tipo Salario" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column field="salarioDiarioIntegrado" header="SDI" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column field="causaBaja" header="Causa Baja" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column field="umf" header="UMF" autoLayout={true} resizableColumns={true}
                                style={{ width: '80px' }} />
                            <Column header="Observaciones" body={this.templateOperacionExitosa} autoLayout={true} resizableColumns={true}
                                style={{ width: '300px' }} />
                        </DataTable>
                        <Paginator first={idsenube} rows={paginacionMovimientos.registrosPorPagina} totalRecords={paginacionMovimientos.registrosTotales} onPageChange={this.cambiaPaginaMovimientos} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                    </div>
                </Dialog>
                <Dialog appendTo={document.body} style={{ width: '90%', height: '90%' }} visible={this.state.verModalHistoricoDeMovimientosRespuesta} header="Respuesta IMSS"
                    onHide={this.cerrarModalLote.bind(this)} modal={true} footer={pieDialogoRespuesta}>
                    <div className="card card-w-title">
                        <div className="p-grid form-group">

                            <div className="p-col-12 p-md-12">
                                <table class="default">
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Lote:</label></td>
                                        <td>{historicoDeMovimiento.loteIdImss}</td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Registro Patronal:</label></td>
                                        <td>{historicoDeMovimiento.registroPatronal}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label style={{ fontWeight: 'bold' }}>
                                                Fecha de transmisión:
                                            </label>
                                        </td>
                                        <td>
                                            {servicioFormatos.formatearFecha(historicoDeMovimiento.fecha)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label style={{ fontWeight: 'bold' }}>Fecha de respuesta:</label></td>
                                        <td>{servicioFormatos.formatearFecha(historicoDeMovimiento.fechaRespuesta)}</td>
                                    </tr>
                                    <tr>
                                        <td> <label style={{ fontWeight: 'bold' }}>Estatus del lote:</label></td>
                                        <td>{historicoDeMovimiento.estado === 0 ? <label>  En Proceso  </label> : null}
                                            {historicoDeMovimiento.estado === 1 ? <label>  Enviado al IMSS  </label> : null}
                                            {historicoDeMovimiento.estado === 2 ? <label>  Respuesta del IMSS  </label> : null}</td>
                                    </tr>
                                </table>
                                <h1>AFIL IDSE 03 Respuesta al patrón</h1>
                                <br></br>
                                <label>Registro Patronal: {historicoDeMovimiento.registroPatronal}</label>
                                <br></br>
                                <label>Nombre: {historicoDeMovimiento.razonSocial}</label>
                                <br></br>
                                <div className="p-col-14 p-md-4">
                                    <Dropdown appendTo={document.body} id="consulta.consolidado" 
                                    name="consulta.consolidado" options={consolidado} 
                                    value={consulta.consolidado} 
                                    onChange={(e) => { this.validarCambioConsolidado(e, false) }} 
                                    autoWidth={false} style={{ width: "90%" }} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-12">
                                <label>Movimientos Afiliatorios</label>
                            </div>
                        </div>


                        <div className="p-col-12">
                            {mostrarTablaConsolidado === false ?
                                <div className="p-col-12">
                                    <div className="card card-w-title">
                                        <DataTable value={listaMovimientos} editable={true} selectionMode="single" responsive={true} header="Movimientos Afiliatorios" paginator={true} rows={20}>
                                            <Column header="Tipo de Movimiento" field="tipoMovimiento" autoLayout={true} />
                                            <Column header="Total" field="total" autoLayout={true} />
                                            <Column header="Error" field="error" autoLayout={true} />
                                            <Column header="Aceptados" field="aceptados" autoLayout={true} />
                                        </DataTable>
                                    </div>
                                </div>
                                : null}
                            {mostrarTablaConsolidado ?
                                <div className="p-col-12">
                                    <div className="card card-w-title">
                                        <DataTable value={paginacionMovimientos.datos} editable={true} selectionMode="single" responsive={true} header="Movimientos Afiliatorios" rows={20} scrollable style={{ width: '1100px' }}>
                                            <Column header="Tipo de Movimiento" field="tipoMovimiento" autoLayout={true} resizableColumns={true}
                                                style={{ width: '50px' }} />
                                            <Column header="NSS" field="numeroSeguridadSocial" autoLayout={true} resizableColumns={true}
                                                style={{ width: '150px' }} />
                                            <Column header="Nombre" body={this.templateNombre} autoLayout={true} resizableColumns={true}
                                                style={{ width: '200px' }} />
                                            <Column header="Fecha Movimiento" body={this.templateFechaMovimiento} autoLayout={true} resizableColumns={true}
                                                style={{ width: '200px' }} />
                                            <Column header="Tipo Trabajador" field="tipoTrabajador" autoLayout={true}
                                                resizableColumns={true}
                                                style={{ width: '100px' }} />
                                            <Column header="Sem/Jorn Red" field="jornadaReducida" autoLayout={true}
                                                resizableColumns={true}
                                                style={{ width: '100px' }} />
                                            <Column header="Tipo Salario" body={this.templateSalarioDiario} autoLayout={true} resizableColumns={true}
                                                style={{ width: '100px' }} />
                                            <Column header="SDI" field="salarioDiarioIntegrado" autoLayout={true} resizableColumns={true}
                                                style={{ width: '100px' }} />
                                            <Column header="UMF" field="umf" autoLayout={true} resizableColumns={true}
                                                style={{ width: '50px' }} />
                                        </DataTable>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}
